import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Appointment.css";
import { useLocale } from "../context/LocaleContext";

const Appointment = () => {
  const { t } = useLocale();
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/reservas");
    }, 4000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <>
      <div className="app_container">
        <div className="upper_container">
          <div className="appointment_booking_section">
            <div className="appointment_booking_container">
              <div className="booking_header">
                <i className="fa-regular fa-clock"></i>
                <span>{t("appointment.slotsBanner")}</span>
              </div>
              <p className="about_info">{t("appointment.info")}</p>
            </div>
            <hr />
            <div className="booking_container">
              <div className="booking_bottom">
                <h3>{t("appointment.bookTitle")}</h3>
                <h4>{t("appointment.noFee")}</h4>
              </div>
              <div className="booking_slot_section">
                <Link to="/reservas">
                  <div className="book_slot">{t("appointment.bookBtn")}</div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Appointment;
